import React, { useState, useEffect } from 'react';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

import BarsTwoIcon from 'Assets/icons/bars-2.svg';
import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function LineItemRow(props) {
    const [sectionWeighting, setSectionWeighting] = useState({});

    useEffect(() => {
        const data = JSON.parse(JSON.stringify(props.itemGroupsWeighting));
        setSectionWeighting(data);
    }, [props]);

    const handleWeightingChange = (value) => {
        const newValue = value.floatValue !== undefined ? value.floatValue : 0;
        props.updateItem(newValue, props.itemKey, 'weighting');
    };

    const handleItemNameChange = (value) => {
        props.updateItem(value, props.itemKey, 'name');
    };

    const handleFocus = (event) => event.target.select();

    const maxVal = (inputObj) => {
        const { value } = inputObj;

        return value <= 100;
    };

    return (
        <div className={`tw-flex ${'section' === props.type ? '!tw-bg-[#F1F1F1]' : 'tw-bg-white'}`}>
            <div className="tw-basis-12 tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-p-1 tw-border-r-2 tw-bg-inherit">
                <button type="button" className="tw-cursor-grab">
                    <BarsTwoIcon className="tw-w-3 tw-h-3" />
                </button>
            </div>
            <div className="tw-basis-full tw-flex tw-items-center">
                <div className="tw-flex tw-basis-6/12 tw-p-1 tw-border-r-2 tw-bg-inherit">
                    <input
                        type="text"
                        className={`tw-border-0 text-input ${'section' === props.type ? '!tw-bg-white' : '!tw-bg-input-background'}`}
                        value={props.name}
                        onChange={(e) => handleItemNameChange(e.target.value)}
                        style={{ flexGrow: 1 }}
                    />
                    {'section' === props.type && (
                        <span className={'cursor-pointer mx-3 tw-flex tw-items-center tw-justify-center'} onClick={props.handleClick}>
                            <ChevronDownIcon className="tw-w-2.5 tw-h-2.5" />
                        </span>
                    )}
                </div>
                {'item' === props.type && (
                    <div className="tw-basis-5/12 tw-p-1 tw-border-r-2 tw-bg-inherit">
                        <NumberFormat
                            value={props.weighting}
                            defaultValue={1}
                            className={`tw-border-0 text-input inbud-numeric-text ${'section' === props.type ? '!tw-bg-white' : '!tw-bg-input-background'}`}
                            decimalScale={0}
                            thousandSeparator={false}
                            inputMode="numeric"
                            allowNegative={false}
                            isAllowed={maxVal}
                            onValueChange={handleWeightingChange}
                            onFocus={handleFocus}
                        />
                    </div>
                )}
                {'section' === props.type && (
                    <div className="tw-basis-5/12 tw-p-1 tw-border-r-2 tw-bg-inherit">
                        <NumberFormat
                            value={$t('Section weighting: ') + (sectionWeighting[props.itemId] || 0) + '%'}
                            defaultValue={1}
                            className={`tw-border-0 text-input inbud-numeric-text ${'section' === props.type ? '!tw-bg-white' : '!tw-bg-input-background'}`}
                            decimalScale={0}
                            thousandSeparator={false}
                            inputMode="numeric"
                            allowNegative={false}
                            isAllowed={maxVal}
                            onValueChange={handleWeightingChange}
                            onFocus={handleFocus}
                            customInput={(props) => <input {...props} disabled />}
                        />
                    </div>
                )}
                <div className="tw-basis-1/12 tw-p-1 tw-border-r-2 tw-bg-inherit tw-flex tw-items-center tw-justify-center">
                    <button type="button" onClick={(e) => props.handleDeleteItem(props.itemKey)}>
                        <TrashIcon className="tw-text-red-500 tw-w-3 tw-h-3" />
                    </button>
                </div>
            </div>
            <div className="tw-basis-12 tw-shrink-0 tw-p-1"></div>
        </div>
    );
}
